export const REMOVE_USER = 'REMOVE_USER'
export const RECEIVE_USER = 'RECEIVE_USER'

export const removeUser = () => ({ type: REMOVE_USER })
export const receiveUser = payload => ({ type: RECEIVE_USER, payload })
